import { isLiquidGlassSupported } from "@-/com.npmjs.callstack__liquid-glass";
import type { PressableProps } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";
import { MenuPopoverSurface } from "#menu-popover-surface";
import { MenuGlassRowsClip } from "#menu-glass-rows-clip";
import { FrostedBackdropOverlay } from "@-/dev.improve.haniverse.components.ui.frosted-surface";

interface MenuPopoverContentOptions {
  /**
   * Clip the content to the glass's corners, concentric inside the menu's `p-1` padding, so a
   * pressed row in a corner never shows past the platter. The surface's own frame cannot clip:
   * it would cut off the glass's shadow. Off iOS Liquid Glass the frame clips instead.
   */
  clipsRows?: boolean;
}

/** Preserve native menu primitives' press-state render props as well as ordinary children. */
export function renderMenuPopoverContent(
  children: ReactNode,
  options?: MenuPopoverContentOptions,
): ReactNode;
export function renderMenuPopoverContent(
  children: PressableProps["children"],
  options?: MenuPopoverContentOptions,
): PressableProps["children"];
export function renderMenuPopoverContent(
  children: PressableProps["children"],
  { clipsRows = true }: MenuPopoverContentOptions = {},
): PressableProps["children"] {
  if (typeof children === "function") {
    return (state) => renderMenuPopoverContent(children(state), { clipsRows });
  }
  return (
    <FrostedBackdropOverlay>
      <MenuPopoverSurface />
      {isLiquidGlassSupported && clipsRows ? (
        <MenuGlassRowsClip>{children}</MenuGlassRowsClip>
      ) : (
        children
      )}
    </FrostedBackdropOverlay>
  );
}
